var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide-down" } }, [
    !_vm.closed
      ? _c(
          "div",
          {
            staticClass: "menu-banner",
            style: { "background-color": _vm.color },
            attrs: { id: _vm.id }
          },
          [
            _c(
              "p",
              [
                _c("b-icon", {
                  staticClass: "mr-3",
                  attrs: { icon: _vm.icon }
                }),
                _vm._v("\n\t\t\t\t" + _vm._s(_vm.text) + "\n\t\t\t\t")
              ],
              1
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d47b1e9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d47b1e9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/ui/BaseMenuBanner.vue
// module id = 2102
// module chunks = 120